<template>
  <v-dialog v-model="dialog" width="550">
    <template v-slot:activator="{}">
      <BaseButton
        v-if="create"
        @click="openModal"
        :minimalize="minimalize"
        :text="
          minimalize
            ? localStorage.translations.pages['common']['buttons']['dobavit']
            : localStorage.translations.pages['setting-employee_roles']['dialogs-add_edit-buttons'][
                'dobavit-dolzhnost'
              ]
        "
        default_icon="button-add"
      />
      <EditBtn v-else :openModal="openModal" />
    </template>
    <transition :duration="150">
      <EmployeeRolesModalForm
        v-if="dialog"
        @input="dialog = false"
        :id="id"
        :dialog="dialog"
        :closeModal="closeModal"
        :create="create"
      />
    </transition>
  </v-dialog>
</template>

<script>
import EditBtn from 'components/EditBtn'
import EmployeeRolesModalForm from 'components/setting/employeeRoles/EmployeeRolesModalForm'

export default {
  name: 'EmployeeRolesModal',
  components: { EmployeeRolesModalForm, EditBtn },
  props: ['id', 'create', 'minimalize'],
  data() {
    return {
      dialog: false,
    }
  },
  watch: {},
  methods: {
    openModal() {
      this.dialog = true
    },
    closeModal() {
      this.dialog = false
    },
  },
}
</script>

<style lang="scss" scoped></style>
